import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    segments: {
        users: {}
    },
    recommendedData: {
        userCollection: [],
        collection: []
    },
    loading: false,
    filteredById: {},
    sortOrder: []
});

// Segment look up looks like
// segments[segmentType][typeId] = [...documentIds]
const getSegments = (byId) => {
    const initialSegments = {
        users: {}
    };
    return Object.values(byId).reduce((segments, doc) => {
        const { userProfileId } = doc;

        if (!segments.users[userProfileId]) {
            segments.users[userProfileId] = [];
        }

        // This is for uniquenss.
        // We shouldn't need includes if we can guarantee
        // uniqueness from the server data. Right now
        // it is just a workaround due to bad data.
        // "Includes" will be slow for larger arrays
        // and should be remove if possible
        if (!(doc._id in segments.users[userProfileId])) {
            segments.users[userProfileId].push(doc._id);
        }
        return segments;
    }, initialSegments);
};

export default (state = getInitialState(), action) => {
    let newById;
    let newFilteredById;
    let reduced;
    switch (action.type) {
        case ACTIONS.GET_MANY_USERLEARNINGASSETS_START: {
            return {
                ...state,
                loading: true
            };
        }

        case ACTIONS.GET_MANY_USERLEARNINGASSETS: {
            newById = { ...state.byId };
            action.payload.userLearningAssets.forEach((userLearningAsset) => {
                newById[userLearningAsset._id] = userLearningAsset;
            });

            return {
                ...state,
                byId: newById,
                segments: getSegments(newById),
                loading: false
            };
        }

        case ACTIONS.GET_FILTERED_USERLEARNINGASSETS: {
            reduced = action.payload.userLearningAssets.reduce((prev, userLearningAsset) => {
                prev[userLearningAsset._id] = userLearningAsset;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };

            return {
                ...state,
                byId: newById,
                filteredById: reduced,
                segments: getSegments(newById),
                loading: false
            };
        }

        case ACTIONS.POST_SEARCHED_USERLEARNINGASSETS: {
            reduced = action.payload.userLearningAssets.reduce((prev, userLearningAsset) => {
                prev[userLearningAsset._id] = userLearningAsset;
                return prev;
            }, {});

            newFilteredById = {
                ...state.filteredById,
                ...reduced
            };

            return {
                ...state,
                filteredById: newFilteredById,
                sortOrder: action.payload.sortOrder,
                loading: false
            };
        }

        case ACTIONS.REMOVE_TEMPORARY_USERLEARNINGASSET: {
            const { userLearningAssetId } = action.payload;
            newById = { ...state.byId };
            delete newById[userLearningAssetId];

            return {
                ...state,
                byId: newById,
                segments: getSegments(newById),
                loading: false
            };
        }
        case ACTIONS.GET_USERLEARNINGASSET:
        case ACTIONS.PUT_USERLEARNINGASSET_SUCCESS:
        case ACTIONS.RESET_USERLEARNINGASSET_SUCCESS:
        case ACTIONS.CREATE_TEMPORARY_USERLEARNINGASSET:
        case ACTIONS.GET_USER_FEEDBACK_ASSET:
        case ACTIONS.PUT_USER_FEEDBACK_ASSET_SUCCESS:
        case ACTIONS.POST_USERLEARNINGASSET_SUCCESS: {
            const { userLearningAsset } = action.payload;
            newById = Object.assign({}, state.byId, {
                [userLearningAsset._id]: userLearningAsset
            });

            return Object.assign({}, state, {
                byId: newById,
                segments: getSegments(newById),
                loading: false
            });
        }
        case ACTIONS.GET_INTERSTITIAL_RECOMMENDATION: {
            const { recommendedData } = action.payload;
            return {
                ...state,
                recommendedData
            };
        }
        case ACTIONS.PUT_COMPLETEDSECTIONITEMDATA_SUCCESS: {
            const { completedSectionItems, userLearningAssetId, updatedOn, status } = action.payload;
            const userLearningAsset = state.byId[userLearningAssetId];
            userLearningAsset.completedSectionItems = completedSectionItems;
            userLearningAsset.updatedOn = updatedOn;
            userLearningAsset.status = status;
            newById = Object.assign({}, state.byId, {
                [userLearningAssetId]: userLearningAsset
            });

            return Object.assign({}, state, {
                byId: newById,
                segments: getSegments(newById),
                loading: false
            });
        }

        case ACTIONS.PUT_USERLEARNINGASSET_METADATA_SUCCESS: {
            const { userLearningAssetId, updatedOn, status } = action.payload;
            const userLearningAsset = state.byId[userLearningAssetId];
            userLearningAsset.updatedOn = updatedOn;
            userLearningAsset.status = status;
            newById = Object.assign({}, state.byId, {
                [userLearningAssetId]: userLearningAsset
            });

            return Object.assign({}, state, {
                byId: newById,
                segments: getSegments(newById),
                loading: false
            });
        }

        case ACTIONS.CLEAR_SEARCHED_USERLEARNINGASSETS: {
            return {
                ...state,
                filteredById: {},
                sortOrder: [],
                loading: false
            };
        }

        case ACTIONS.CLEAR_USERLEARNINGASSETS:
            return {
                ...state,
                byId: {},
                sortOrder: [],
                loading: false
            };

        default:
            return state;
    }
};
